const namespaced = true;

const state = {};

const getters = {};

const actions = {};

const mutations = {};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
